import React from 'react'
import { ImageComp } from '../../../Components/ImageCompo/ImageComp'
import ButtonComp from '../../../Components/ButtonComp/ButtonComp'

const HeaderRedirection = () => {
    return (
        <>
            <div className='flex px-[30px] shadow- justify-between py-[20px]'>
                <div>
                    <ImageComp className='h-[40px] overflow-hidden object-cover' source='./Images/logo.png' />
                </div>
                <div>
                    <ButtonComp className='px-[30px] py-[5px] rounded-full bg-[#004878] text-[white] border-none' text='View Profile' />
                </div>
            </div>
        </>
    )
}

export default HeaderRedirection